// @ts-nocheck
import Groomer from "~/content/groomer";
import Title from "~/content/title";
import { CONFIG } from "~/config";
import { store } from "~/state/store";
import { saveHistory } from "~/util/providers/history";
import { openAdminDetail } from "~/util/userweb";
import { iframeAnalyticsLog } from "~/util/analyticsAction";
import SceneMarkerMapyWindySearch from "~/scene/marker/mapy-windy-search";
import Scene from "~/scene";
import { openCadastralEntity } from "~/cadastral";
import { isDetailActive } from "~/util/detail";
import { unsetDetail } from "~/state/detail/state";
import { getMapsetBySEO } from "~/util/mapset";
import { watch, watchMapset, watchCoordinates } from "~/state/util";
import { Unsubscribe } from "redux";
import { MAP_OVERLAYS } from "~/state/map/constants";
import { IMapState } from "~/state/map/interfaces";
import DataProvider from "~/data-provider";
import DataProviderCadastral from "~/data-provider-cadastral";
import FotoWCamDataProvider from "./windy-webcam/data-provider";
import PoiaggLookupbox from "~/util/providers/lookupbox/poiagg";
import CadastralLookupbox from "./util/providers/lookupbox/cadastral";
import FotoWcamLookupbox from "./util/providers/lookupbox/foto-wcam";
//import { lookupbox } from "./util/providers/poiagg";
import { debounce } from "./lib/debounce";
import { setCoordinates } from "~/state/map/state";
import { description } from "./util/providers/poiagg";

const GEOMETRY_CARD_SOURCES = ["bs"];
const POISERVERS = {
	POIAGG: "poiagg",
	SKI: "ski",
	TRAFFIC: "traffic",
	CADASTRAL: "cadastral",
	FOTO: "foto",
};

function stateToLookupMapset(state: IMapState) {
	if (state.mapset === "letecka") {
		if (state.mapset in state.currentOverlays && state.currentOverlays[state.mapset].indexOf(MAP_OVERLAYS.TRAFFIC) !== -1) {
			return "letecka-dopravni";
		} else if (state.mapset in state.currentOverlays && state.currentOverlays[state.mapset].indexOf(MAP_OVERLAYS.TURIST) !== -1) {
			return "letecka-turisticka";
		}

		return "letecka-zakladni";
	}

	return state.mapset;
}

function isMapsetContainsLayer(curState: IMapState, layerId: number) {
	return curState.mapset in curState.currentOverlays && curState.currentOverlays[curState.mapset].indexOf(layerId) !== -1;
}

export default class Pois {
	_storeMapsetUnsubscribe: Unsubscribe;

	_storeCoordinatesUnsubscribe: Unsubscribe;

	_dataProvider: DataProvider;

	_ccSkiDataProvider: DataProvider;

	_fotoDataProvider: FotoWCamDataProvider;

	_cadastralDataProvider: DataProvider;

	_poiaggLookupbox: PoiaggLookupbox;

	_fotoWcamLookupbox: FotoWcamLookupbox;

	_lastZoom: number;

	_changeWidthListener: string;

	constructor(trafficLayer, winterLayer) {
		this._sc = [];
		this._cadastral = null;
		this._dataProvider = new DataProvider();
		// bezky mohou byt navic k ostatnim POIum
		this._ccSkiDataProvider = new DataProvider();
		// fotky mohou byt navic k ostatnim POIum
		this._fotoDataProvider = new FotoWCamDataProvider();
		// doprava je navic jen v letecke, ktera nema POIe, ale diky extra dataprovideru mit muze a nerozbije se
		this._trafficDataProvider = new DataProvider();
		this._cadastralDataProvider = new DataProviderCadastral();
		this._layers = {
			lookup: Scene.createLayerMapyLookup(),
			trafficLookup: Scene.createLayerMapyLookup(),
			fotoWcamLookup: Scene.createLayerMapyLookup(),
			cadastralLookup: Scene.createLayerMapyLookup(),
			foto: Mapy.getComponent("masakovac"),
			fotoWcamLayerMarker: Scene.createLayerMarker(),
			fotoWcamDetailLayerMarker: Scene.createLayerMarker(),
			trafficMarker: Scene.createLayerMasakovac(),
			trafficGeometry: Scene.createLayerGeometry("traffic-geometry"),
			marker: Mapy.getComponent("masakovac"),
			geometry: Scene.createLayerGeometry("geometry"),
			dummyGeometry: Scene.createLayerGeometry("dummy-geometry"),
			cadastralGeometry: Scene.createLayerGeometry("cadastral-geometry"),
		};
		// FIXME fotomapy provizorni reseni, nez upravi poiaggregator
		this._fotomapyState = false;
		this._isMapsetFoto = false;
		this._isMapsetCadastral = false;
		this._firstRun = true;
		this._activeCard = null;
		this._card = null;
		this._cardHideTimeout = 0;
		this._cardShowTimeout = 0;
		this._cardDisabled = false;
		this._changeWidthListener = "";
		this._poiaggLookupbox = new PoiaggLookupbox();
		this._fotoWcamLookupbox = new FotoWcamLookupbox();
		this._forceRequest = debounce((bool: boolean) => {
			this._dataProvider.forceRequest(bool);
			this._ccSkiDataProvider.forceRequest(bool);
			this._trafficDataProvider.forceRequest(bool);
		}, 100);

		this._layers.marker.setReposition({});
		this._layers.lookup.addMarkerLayer(this._layers.marker);
		this._layers.lookup.addGeometryLayer(this._layers.geometry);
		this._layers.trafficLookup.addMarkerLayer(this._layers.trafficMarker);
		this._layers.trafficLookup.addGeometryLayer(this._layers.trafficGeometry);
		this._layers.fotoWcamLookup.addMarkerLayer(this._layers.fotoWcamLayerMarker);
		this._layers.fotoWcamLookup.addGeometryLayer(this._layers.dummyGeometry);
		this._layers.cadastralLookup.addMarkerLayer(Scene.createLayerMarker());
		this._layers.cadastralLookup.addGeometryLayer(this._layers.cadastralGeometry);

		this._dataProvider.addLayer(this._layers.lookup);
		this._trafficDataProvider.addLayer(this._layers.trafficLookup);
		this._fotoDataProvider.addLayer(this._layers.fotoWcamLookup);
		// nastavime si vrstvy
		this._fotoDataProvider.addCustomLayers({
			layerMarker: this._layers.fotoWcamLayerMarker,
			detailLayerMarker: this._layers.fotoWcamDetailLayerMarker,
		});
		this._cadastralDataProvider.addLayer(this._layers.cadastralLookup);
		this._dataProvider.addTrafficLayer(trafficLayer);
		// diky tomuhle nebude treba upravit zimni mapset, dokud definitivne nevypneme stare ovladaci prvky - jen se tedy budou stopy tahat dvakrat (ale zobrazovat jen jednou)
		this._ccSkiDataProvider.addWinterLayer(winterLayer);

		Scene.addListener("marker-poi-click", "_markerClick", this);
		Scene.addListener("geometry-click", "_geometryClick", this);
		Scene.addListener("geometry-canvas-mouseover", "_geometryMouseOver", this);
		Scene.addListener("geometry-canvas-mouseout", "_geometryMouseOut", this);
		Scene.addListener("geometry-multi-click", "_geometryClick", this);
		Scene.addListener("geometry-canvas-click", "_geometryClick", this);
		Scene.addListener("provider-changed", event => {
			const data = event.data;

			if (data.firstChange) {
				return;
			}

			// vyvola nacteni poiu + search pokud predtim byl
			if (data.name === "map") {
				this._redrawAll(true);
			} else if (data.name === "m3d") {
				Scene.makeEvent("map-redraw", {}, null);
			}
		});

		document.body.addEventListener("pointerdown", this, false);
		document.body.addEventListener("pointerup", this, false);

		const wtMapset = watch(store.getState, "map", watchMapset);

		this._storeMapsetUnsubscribe = store.subscribe(wtMapset((newMapset, oldMapset) => {
			// chceme cernou
			if (["letecka"].indexOf(newMapset.mapset) === -1) {
				this._layers.cadastralGeometry.setOptions({ className: "invert" });
			// chceme bilou
			} else {
				this._layers.cadastralGeometry.setOptions({ className: "" });
			}

			// pri letecke musime kontrolovat, jestli jeste navic nechce videt dopravu nebo turisticke znacky, protoze pokud ano, tak hlavni lookup bude podle nich a ne letecka
			const oldPoiMapset = stateToLookupMapset(oldMapset);
			const newPoiMapset = stateToLookupMapset(newMapset);

			if (oldPoiMapset !== newPoiMapset) {
				const mapset = getMapsetBySEO(newPoiMapset);

				this.setMapset(mapset.id);
			}

			if (isMapsetContainsLayer(newMapset, MAP_OVERLAYS.SKI)) {
				this._ccSkiDataProvider.enable();
			} else {
				this._ccSkiDataProvider.disable();
			}

			if (isMapsetContainsLayer(newMapset, MAP_OVERLAYS.TRAFFIC)) {
				this._dataProvider.addTrafficLayer(undefined);
				this._trafficDataProvider.addTrafficLayer(trafficLayer);
				this._trafficDataProvider.enable();
			} else {
				this._dataProvider.addTrafficLayer(trafficLayer);
				this._trafficDataProvider.addTrafficLayer(undefined);
				this._trafficDataProvider.disable();
			}

			const hasPhoto = isMapsetContainsLayer(newMapset, MAP_OVERLAYS.PHOTO);
			const hasWebcams = isMapsetContainsLayer(newMapset, MAP_OVERLAYS.WEBCAM);

			if (hasPhoto || hasWebcams) {
				this._fotoWcamLookupbox.setSources({
					foto: hasPhoto,
					webcams: hasWebcams,
				});
				this._fotoDataProvider.enable();
			} else {
				this._fotoDataProvider.disable();
			}

			if (isMapsetContainsLayer(newMapset, MAP_OVERLAYS.CADASTRAL)) {
				this._cadastralDataProvider.enable();
			} else {
				this._cadastralDataProvider.disable();
			}
		}));

		const wtCoordinates = watch(store.getState, "map", watchCoordinates);

		this._storeCoordinatesUnsubscribe = store.subscribe(wtCoordinates((newMap, oldMap) => {
			if (newMap.animating) {
				if (oldMap.zoom !== newMap.zoom) {
					this._lastZoom = oldMap.zoom;
				}

				this._disableCard();
			} else {
				this._enableCard();

				if (Scene.isMapActive()) {
					this._redrawAll(this._lastZoom !== newMap.zoom || newMap.zoom !== oldMap.zoom);
				}

				if (Scene.isM3dActive() && this._isMapsetFoto) {
					const viewport = Scene.getViewport();
					const opts = {
						zoom: newMap.zoom,
						mapsetId: 26,
						lang: CONFIG.langPriority,
						sources: ["foto"],
					};

					// pouze lookupbox pro fotky, ne poie!
					lookupbox(viewport.lbx, viewport.lby, viewport.rtx, viewport.rty, opts).promise.then(lookupData => {
						this._layers.lookup.removeAll();
						this._layers.lookup.fillFromData(lookupData);
					}, () => {});
				}

				this._lastZoom = oldMap.zoom;
			}
		}));

		const state = store.getState().map;
		const mapset = getMapsetBySEO(stateToLookupMapset(state));

		this._lastZoom = state.zoom;
		this.init();
		this.setMapset(mapset.id);

		if (isMapsetContainsLayer(state, MAP_OVERLAYS.SKI)) {
			this._ccSkiDataProvider.enable();
		} else {
			this._ccSkiDataProvider.disable();
		}

		if (isMapsetContainsLayer(state, MAP_OVERLAYS.TRAFFIC)) {
			this._dataProvider.addTrafficLayer(undefined);
			this._trafficDataProvider.addTrafficLayer(trafficLayer);
			this._trafficDataProvider.enable();
		} else {
			this._dataProvider.addTrafficLayer(trafficLayer);
			this._trafficDataProvider.addTrafficLayer(undefined);
			this._trafficDataProvider.disable();
		}

		const hasPhoto = isMapsetContainsLayer(state, MAP_OVERLAYS.PHOTO);
		const hasWebcams = isMapsetContainsLayer(state, MAP_OVERLAYS.WEBCAM);

		if (hasPhoto || hasWebcams) {
			this._fotoWcamLookupbox.setSources({
				foto: hasPhoto,
				webcams: hasWebcams,
			});
			this._fotoDataProvider.enable();
		} else {
			this._fotoDataProvider.disable();
		}

		if (isMapsetContainsLayer(state, MAP_OVERLAYS.CADASTRAL)) {
			this._cadastralDataProvider.enable();
		} else {
			this._cadastralDataProvider.disable();
		}
	}

	destroy() {
		document.body.removeEventListener("pointerdown", this, false);
		document.body.removeEventListener("pointerup", this, false);
	}

	init() {
		Scene.addLayer(this._layers.trafficLookup, true);
		Scene.addLayer(this._layers.lookup, true).enable();
		Scene.addLayer(this._layers.cadastralLookup, true);

		this._dataProvider.enable();

		this._fotoDataProvider.addPOIServer({
			poiserver: POISERVERS.FOTO,
			lookupBoxClass: this._fotoWcamLookupbox,
		});
		Scene.addLayer(this._layers.fotoWcamLookup, true);

		const skiPoiagg = new PoiaggLookupbox();
		const trafficPoiagg = new PoiaggLookupbox();

		skiPoiagg.mapset = getMapsetBySEO("zimni-stopy").id;
		trafficPoiagg.mapset = getMapsetBySEO("dopravni").id;

		this._ccSkiDataProvider.addPOIServer({
			poiserver: POISERVERS.SKI,
			lookupBoxClass: skiPoiagg,
		});
		this._trafficDataProvider.addPOIServer({
			poiserver: POISERVERS.TRAFFIC,
			lookupBoxClass: trafficPoiagg,
		});
		this._cadastralDataProvider.addPOIServer({
			poiserver: POISERVERS.CADASTRAL,
			lookupBoxClass: new CadastralLookupbox(),
		});

		this._switchPoiservers();

		const state = store.getState().map;

		// chceme cernou
		if (["letecka"].indexOf(state.mapset) === -1) {
			this._layers.cadastralGeometry.setOptions({ className: "invert" });
		// chceme bilou
		} else {
			this._layers.cadastralGeometry.setOptions({ className: "" });
		}

		if (isMapsetContainsLayer(state, MAP_OVERLAYS.SKI)) {
			this._ccSkiDataProvider.enable();
		} else {
			this._ccSkiDataProvider.disable();
		}

		if (isMapsetContainsLayer(state, MAP_OVERLAYS.TRAFFIC)) {
			this._dataProvider.addTrafficLayer(undefined);
			this._trafficDataProvider.addTrafficLayer(Mapy.getComponent("layerManager").getTrafficLayer());
			this._trafficDataProvider.enable();
		} else {
			this._dataProvider.addTrafficLayer(Mapy.getComponent("layerManager").getTrafficLayer());
			this._trafficDataProvider.addTrafficLayer(undefined);
			this._trafficDataProvider.disable();
		}

		const hasPhoto = isMapsetContainsLayer(state, MAP_OVERLAYS.PHOTO);
		const hasWebcams = isMapsetContainsLayer(state, MAP_OVERLAYS.WEBCAM);

		if (hasPhoto || hasWebcams) {
			this._fotoWcamLookupbox.setSources({
				foto: hasPhoto,
				webcams: hasWebcams,
			});
			this._fotoDataProvider.enable();
		} else {
			this._fotoDataProvider.disable();
		}

		if (isMapsetContainsLayer(state, MAP_OVERLAYS.CADASTRAL)) {
			this._cadastralDataProvider.enable();
		} else {
			this._cadastralDataProvider.disable();
		}
	}

	handleEvent(event) {
		switch (event.type) {
			case "pointerdown":
				if (!this._card || !this._card.container.contains(event.target)) {
					this._disableCard();
				}
				break;

			case "pointerup":
				this._enableCard();
				break;

			default:
				break;
		}
	}

	setFotomapyState(state) {
		this._fotomapyState = state;

		return this;
	}

	updatePoiaggOpts(customOpts: any) {
		this._poiaggLookupbox.updateOpts(customOpts);
	}

	setMapset(mapset: string) {
		const state = store.getState().map;

		//FIXME fotomapy hack
		this._isMapsetFoto = state.mapset === "fotografie";
		this._isMapsetCadastral = state.mapset === "katastralni";

		this.updatePoiaggOpts({
			...state.mapset === "uzavirky" ? Mapy.getComponent("closureSwitch").getState() : {},
		});

		this._poiaggLookupbox.mapset = mapset;

		this._switchPoiservers();
	}

	forceRequest(bool: boolean) {
		this._forceRequest(bool);
	}

	_switchPoiservers() {
		if (this._isMapsetCadastral) {
			this._dataProvider.removePOIServer(POISERVERS.POIAGG);
		} else if (!this._fotomapyState && !this._isMapsetFoto) {
			this._dataProvider.addPOIServer({
				poiserver: POISERVERS.POIAGG,
				lookupBoxClass: this._poiaggLookupbox,
			});
		} else {
			this._dataProvider.addPOIServer({
				poiserver: POISERVERS.POIAGG,
				lookupBoxClass: this._poiaggLookupbox,
			});
		}

		//FIXME krome prvniho lookupu si musim s kazdou zmenou rict o dalsi lookup
		if (!this._firstRun) {
			this._forceRequest(true);
		}

		this._firstRun = false;
	}

	_markerClick(event) {
		const marker = event.target;
		const markers = [
			...this._layers.marker.getMarkers(),
			...this._layers.fotoWcamLayerMarker.getMarkers(),
		];

		if (marker.isDetail()) {
			Mapy.getComponent("detail").refreshPanel();

			return;
		}

		if (markers.indexOf(marker) < 0) {
			return;
		}

		// odstranime kartu
		marker.removeCard();

		const source = marker.getSource();
		const id = marker.getPlainId();
		const mapsetState = store.getState().map;

		if (CONFIG.inFrame) {
			if (!isDetailActive(store.getState())) {
				iframeAnalyticsLog({
					type: "click-back",
					referrer: document.referrer,
					form: "other",
				});
				window.open(`${CONFIG.mapyURL}/${mapsetState.mapset}?source=${source}&id=${id}`);
			}
		} else if (["foto", "ffoto"].indexOf(source) > -1) {
			Mapy.getComponent("photoDetail").setData({
				source: source,
				id: id,
				onClose: (type, data) => {
					if (type === "close-map-click" && data && data.mark) {
						store.dispatch(setCoordinates({
							longitude: data.mark.lon,
							latitude: data.mark.lat,
							zoom: 19,
							animate: true,
						}));
					}
				},
			}).activate();

			Mapy.getComponent("history").save();
		} else if (mapsetState.mapset === "uzavirky" && marker.getCreateData()?.fromData?.past) { // klik na minule uzavirky otevre detail v poiadminu
			openAdminDetail(source, id);
		} else {
			// i kdyz si detail ridi sam zobrazeni layoutu - pokud jsem v panorame a kliknu na detail poie -> chci videt jeho detail; nyni se detail zobrazi na "pozadi"
			Mapy.getComponent("layout").setWidth(1);

			if (isDetailActive(store.getState()) && Mapy.getComponent("gpx").isActive()) {
				store.dispatch(unsetDetail());
			}

			Mapy.getComponent("detail").setState({
				source: source,
				id: id,
				manual: true,
				show: false,
				fromMarker: marker,
				search: Mapy.getComponent("detail").getSuggestConf(),
			}).then(() => {
				if (marker instanceof SceneMarkerMapyWindySearch) {
					const poi = marker.getPOI();

					if (poi) {
						const { user } = store.getState().user;

						saveHistory(user, {
							title: poi.title,
							source: "web",
							type: "poi",
							data: {
								entitySource: source,
								entityId: id,
								lon: poi.mark.lon,
								lat: poi.mark.lat,
							},
						}).then(() => {}, () => {});
					}
				}
				Mapy.getComponent("history").save();
			}, () => {});
		}
	}

	_geometryClick(eventClick) {
		if (Mapy.getComponent("route").isActive() || Mapy.getComponent("distanceMeter").isActive()) {
			return;
		}

		const geometry = eventClick.target;
		let source = "";
		let id = 0;

		if (eventClick.type === "geometry-canvas-click") {
			source = geometry.source;
			id = geometry.id;
		} else {
			const options = geometry.getOptions();

			if (!options || !options.clickable) {
				return;
			}

			source = geometry.getSource();
			id = geometry.getPlainId();
		}

		if (store.getState().map.mapset === "uzavirky" && geometry.getClosureType() === "past") { // klik na minule uzavirky otevre detail v poiadminu
			openAdminDetail(source, id);
		} else if (source === "plot") {
			openCadastralEntity(source, id, geometry);
		} else {
			this._removeCard();

			Mapy.getComponent("detail").setState({
				source: source,
				id: id,
				manual: true,
				show: false,
			}).then(() => {
				Mapy.getComponent("history").save();
			}, () => {});
		}
	}

	_geometryMouseOver(eventMouseover) {
		this._cardShowTimeout = setTimeout(() => {
			if (Mapy.getComponent("route").isActive() || Mapy.getComponent("distanceMeter").isActive() || this._cardDisabled) {
				return;
			}

			const source = eventMouseover.target.source;
			const id = eventMouseover.target.id;

			if (this._activeCard && source === this._activeCard.source && id === this._activeCard.id) {
				this._cancelCardRemove();
			} else if (GEOMETRY_CARD_SOURCES.indexOf(source) !== -1) {
				this._activeCard = {
					source: source,
					id: id,
				};

				description([{ source, id }], {
					fetchPhoto: true,
					ratios: ["1x1"],
					lang: CONFIG.langPriority,
					query: Mapy.getComponent("search").getQuery(),
					wikimedia: true,
				}).then(data => {
					const poi = data.poi.length ? data.poi[0] : null;

					if (poi && this._activeCard && this._activeCard.source === poi.source && this._activeCard.id === poi.id) {
						this._cancelCardRemove();
						this._removeCard();
						this._card = new Mapy.Card();
						const container = this._card.container;

						container.classList.add("geometry-popup");
						container.addEventListener("mouseleave", () => {
							this._requestCardRemove();
						});
						container.addEventListener("mouseenter", () => {
							this._cancelCardRemove();
						});
						const body = this._card.body;

						Mapy.Util.clear(body);
						const title = new Title({ title: poi.titleVars ? poi.titleVars.titleMain : poi.title });

						body.appendChild(title.getContainer());
						const groomer = new Groomer(poi.extend.groom);

						body.appendChild(groomer.getContainer());
						this._card.open({
							bbox: Scene.getContainer().getBoundingClientRect(),
							offsetX: 0,
							offsetY: -20,
							x: eventMouseover.data.event.clientX,
							y: eventMouseover.data.event.clientY,
						});
					}
				}, () => {});
			}
		}, 200);
	}

	_geometryMouseOut(eventMouseout) {
		const source = eventMouseout.target.source;

		this._cancelCardShow();

		if (GEOMETRY_CARD_SOURCES.indexOf(source) !== -1) {
			this._requestCardRemove();
		}
	}

	_removeCard() {
		if (!this._card) {
			return;
		}

		this._activeCard = null;
		this._card.destroy();
		this._card = null;
	}

	_requestCardRemove() {
		this._cardHideTimeout = setTimeout(() => this._removeCard(), 1000);
	}

	_cancelCardShow() {
		if (this._cardShowTimeout) {
			clearTimeout(this._cardShowTimeout);
			this._cardShowTimeout = 0;
		}
	}

	_cancelCardRemove() {
		if (this._cardHideTimeout) {
			clearTimeout(this._cardHideTimeout);
			this._cardHideTimeout = 0;
		}
	}

	_disableCard() {
		this._cardDisabled = true;
		this._removeCard();
	}

	_enableCard() {
		this._cardDisabled = false;
	}

	_redrawAll(full?: boolean) {
		this._dataProvider.forceRequest(full);
		this._ccSkiDataProvider.forceRequest(full);
		this._fotoDataProvider.forceRequest(full);
		this._trafficDataProvider.forceRequest(full);
		this._cadastralDataProvider.forceRequest(full);
	}
}
